import moment from 'moment-timezone';
import { getInsertionOrderFlightsSpent } from 'sonata-static-storage/lib/entities';
import { normalizeWithUnit } from 'sonata-static-storage/lib/helpers/i18nUnits.helpers';
import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';
import { InsertionOrderFlight } from 'sonata-static-storage/lib/schemas/multiFlight/insertionOrderFlight.schema';

import { IoSettingsStore } from '@/store/local/ioSettings';

export type IoSettingValidationError = {
  error: string;
  extraData?: Record<string, any>;
};

const getActiveFlights = (flights: InsertionOrderFlight[]): InsertionOrderFlight[] => {
  const today = moment.utc().startOf('day');
  return flights.filter(({ beginDate, endDate }) => {
    return today.isBefore(moment.utc(beginDate)) && today.isSameOrAfter(moment.utc(endDate));
  });
};

export const isValidIoSettings = async (
  io: IoSettingsStore,
  currencyInfo: Record<string, any>,
  userId: string,
  flightsSpendToken: Record<string, any>
): Promise<IoSettingValidationError[]> => {
  const errors: IoSettingValidationError[] = [];
  if (io._id && !!io.completed) {
    const ioFlightsSpent = await getInsertionOrderFlightsSpent(userId, io._id, flightsSpendToken).catch(() => []);
    const activeFlights = getActiveFlights(io.flights);
    activeFlights.find(({ _id, goal, name }) => {
      const flightSpent = ioFlightsSpent.find(({ flightId }) => flightId === _id);
      if (flightSpent && goal.target && flightSpent.spent > goal.target) {
        errors.push({
          error: 'flightBudget',
          extraData: {
            flightCurrentSpend: normalizeWithUnit(flightSpent.spent, currencyInfo, 2),
            flightName: name
          }
        });
        return true;
      }
      return false;
    });
  }
  return errors;
};

export const formatMediaChannel = (mediaChannel: CampaignFamilyEnum) => {
  if (mediaChannel === 'ctv') {
    return mediaChannel.toUpperCase();
  }
  return mediaChannel.charAt(0).toUpperCase() + mediaChannel.slice(1);
};

export const getBeginAndEndDateFromFlights = (flights: InsertionOrderFlight[]) => {
  const nonDeletedFlights = flights.filter(flight => !flight.deleted);
  const beginDates = nonDeletedFlights.map(flight => moment.utc(flight.beginDate));
  const endDates = nonDeletedFlights.map(flight => moment.utc(flight.endDate));

  return {
    begin: moment.min(beginDates),
    end: moment.max(endDates)
  };
};
